<template>
  <div v-if="drawComponent">
    <div class="row" v-if="showForm">
      <div class='col-sm-6'>
        <panel id="vizpan" :title='"New Project"' :footerShow="true">
          <div class="row" id="visrow">
            <form @submit.prevent="saveData()">
            <div class="row">
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <input type="text" v-model="object.name" placeholder="Project name" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('budget') }">
                      <input type="text" v-model="object.latitude" placeholder="Latitude" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('budget') }">
                      <input type="text" v-model="object.longitude" placeholder="Longitude" class="form-control"/>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('budget') }">
                      <input type="text" v-model="object.address" placeholder="Address" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('budget') }">
                      <input type="text" v-model="object.zip" placeholder="ZIP" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('budget') }">
                      <input type="text" v-model="object.city" placeholder="City" class="form-control"/>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('computedSum') }">
                      <input type="text" v-model="object.youtube_url" placeholder="Youtube URL" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div class="input-group" :class="{'has-error': errors.has('computedSum') }">
                      <input type="text" v-model="object.transfer_tax" placeholder="Transfer Tax" class="form-control"/>
                      <span class="input-group-addon">%</span>
                    </div>
                  </div>
                  <div class="col-sm-4 mt-5">
                    <label class="control-label valign-middle mr-10">Public project</label>
                    <toggle-button :value="!!object.is_public" :sync="true" :labels="true" @change="changePublicProject"/>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="tabbable">
                  <ul class="nav nav-tabs nav-tabs-top">
                    <li class="active"><a href="#top-tab0" data-toggle="tab">Details</a></li>
                    <li><a href="#top-tab1" data-toggle="tab">More info</a></li>
                    <li><a href="#top-tab2" data-toggle="tab">Equipment</a></li>
                    <li><a href="#top-tab3" data-toggle="tab">Other info</a></li>
                  </ul>

                  <div class="tab-content">
                    <div id="top-tab0" class="tab-pane active">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group" :class="{'has-error': errors.has('delivery') }">
                            <textarea rows="6" v-model="object.details" class="form-control"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="top-tab1" class="tab-pane">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group" :class="{'has-error': errors.has('location') }">
                            <textarea rows="6" v-model="object.more" class="form-control"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div id="top-tab2" class="tab-pane">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group" :class="{'has-error': errors.has('budget') }">
                            <textarea rows="6" v-model="object.equipment" class="form-control"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div id="top-tab3" class="tab-pane">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group" :class="{'has-error': errors.has('budget') }">
                            <textarea rows="6" v-model="object.other" class="form-control"></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </form>
          </div>
          <div slot="footerElements">
            <div class="pull-right">
              <router-link tag="button" :to="{name: 'project'}" class="btn btn-link legitRipple">Cancel</router-link>
              <button type="submit" @click.prevent="saveData()" :disabled="errors.any()" class="btn btn-primary legitRipple">Save changes</button>
            </div>
          </div>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ToggleButton from 'vue-js-toggle-button/src/Button'

import ProjectService from '@/services/project.service'
import ApartmentService from '@/services/apartment.service'

import Panel from '@/components/_partial/_atomic/panel'
import Modal from '@/components/Modal'
import ApartmentForm from '../apartment/Form'
import UploadForm from '@/components/_partial/UploadForm'
import ApartmentList from '../apartment/_partial/List'

export default {
  name: 'ProjectForm',
  components: { ApartmentList, UploadForm, ApartmentForm, Panel, Modal, ToggleButton },

  props: ['entity', 'oid'],
  data () {
    return {
      id: null,
      object: {},
      images: [],
      idFilter: [],
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: ProjectService,
      apartmentService: new ApartmentService(),
      statuses: [],
      systemStatuses: [],
      apartmentStatuses: [],
      apartmentAvailableStatuses: [],
      groupStatuses: [],
      showForm: false,
      mode: {
        statusMap: {},
        apartmentStatusMap: {},
        resetAfterMount: false,
        readonly: true
      },
      /** **/
      currentApartment: { data: {} },
      selectedItems: [],
      /** **/
      editMode: false,
      galleryEditMode: false,
      /** **/
      addApartmentMode: false,
      viewApartmentMode: false,
      apartmentEditMode: false,
      /** **/
      hasChanges: false,
      savingChanges: false,
      drawComponent: true
    }
  },

  computed: {
    activeImages: function () {
      return this.images.filter(img => {
        return !img.isDeleted
      })
    }
  },

  beforeMount () {
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.apartmentStatusMap = {
      'label-danger': 3,
      'bg-orange-300': 2,
      'label-success': 1
    }
    this.apartmentStatuses = [
      '',
      'Available', // 1
      'Reserved', // 2
      'Sold' // 3
    ]
    for (let i = 1; i < this.apartmentStatuses.length; i++) {
      this.apartmentAvailableStatuses.push(this.apartmentStatuses[i])
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.groupStatuses = Vue.config.statusGroups['project'] ? Vue.config.statusGroups['project'] : Vue.config.statusGroups['*']
    this.statuses = []
    for (let i = 0; i < this.groupStatuses.length; i++) {
      this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
    }
  },

  watch: {
    '$route': 'flushObjectIfRequired'
  },

  mounted () {
    // let promises = []
    this.reset(true)
    this.refresh()
    this.mode.resetAfterMount = false
  },

  methods: {
    selectionChanged (ids) {
      this.selectedItems = ids
    },

    makeOffer () {
      if (this.selectedItems.length) {
        this.$router.push({ 'name': 'sale.create', params: { apartments: this.selectedItems } })
      } else {
        this.$popup.warning('Select at least one apartment to make offer')
      }
    },

    flushObjectIfRequired () {
      console.log(this.$route)
      if (this.$route.name === 'project.create') {
        this.id = false
        this.mode.resetAfterMount = true
        // this.object = {}
        for (let i in this.service.__itemTemplate) {
          this.object[i] = this.service.__itemTemplate[i]
        }
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
        this.hardReset()
      } else {
        if (this.oid) {
          this.refreshFromServer()
        }
      }
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
        this.makeIdFilter()
        this.object = this.object
      })
    },

    reset (forceItemReset = true) {
      this.hasChanges = false
      if (typeof this.entity === 'object' && this.entity.hasOwnProperty('id')) {
        for (let i in this.entity) {
          if (this.entity.hasOwnProperty(i)) {
            this.object[i] = this.entity[i]
            if (i === 'required_at') {
              this.object.period = this.$moment(this.object[i]).format(Vue.config.localizedFormat.date)
            }
          }
        }
        this.id = this.entity.id
        forceItemReset = false
      }
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
      this.makeIdFilter()
    },

    refreshFromServer () {
      this.service.item(this.oid, result => {
        for (let i in result) {
          if (result.hasOwnProperty(i)) {
            this.object[i] = result[i]
          }
        }
        this.id = this.object.id
        this.setupGallery()
        this.$emit('loadObject', this.object)
        this.showForm = true
        this.$emit('shown', this.object)
        this.hardReset()
      })
    },

    refresh (newInstance) {
      if (!this.object.id && this.oid) {
        this.refreshFromServer()
      } else {
        if (newInstance) {
          for (let i in newInstance) {
            if (newInstance.hasOwnProperty(i)) {
              this.object[i] = newInstance[i]
            }
          }
          this.id = this.object.id
          this.setupGallery()
          this.$emit('assignObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        }
        this.showForm = true
        this.$emit('shown', this.object)
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      this.makeIdFilter()
    },

    setItemStatus (item, status) {
      this.service.update(item, { 'id': item, 'status': status }, result => {
        this.service.item(result.id, newdata => {
          this.refresh(newdata)
          this.hasChanges = true
          this.hasChanges = false
        })
      }, () => {
        this.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    setApartmentItemStatus (item, status) {
      let $vm = this
      this.apartmentService.update(item, { 'id': item, 'status': status }, result => {
        this.apartmentService.item(result.id, () => {
          this.reset()
        })
      }, () => {
        $vm.$popup.warning('Can\'t set item STATUS on server')
      })
    },

    saveData () {
      if (this.id) {
        this.service.update(this.id, this.prepareData(this.object), () => {
          this.mode.readonly = true
          this.refreshFromServer()
        })
      } else {
        this.service.create(this.prepareData(this.object), result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[i] = result[i]
            }
          }
          this.$router.push('/project/details/' + parseInt(this.object.id))
        })
      }
    },

    enterEditMode () {
      this.editMode = true
      this.showForm = false
      this.showForm = true
    },

    cancelEditMode () {
      this.editMode = false
      this.showForm = false
      this.showForm = true
    },

    saveChanges () {
      // let promises = []
      if (this.hasChanges) {
        /* this.savingChanges = true
                this.object.purchaseOrderProducts.forEach(item => {
                  promises.push(PoProductService.update(this.id, item.id, item))
                })
                Promise.all(promises).then(() => {
                  this.savingChanges = false
                  this.hasChanges = false
                  this.reset()
                }) */
      }
    },

    addApartment () {
      this.$refs.apartmentForm.saveData()
    },

    saveApartment () {
      this.$refs.apartmentViewForm.saveData()
    },

    addApartmentClick () {
      this.addApartmentMode = true
    },

    viewApartmentClick (id) {
      let $vm = this
      if (typeof id === 'object') {
        $vm.currentApartment = id
        $vm.showLoader = false
        $vm.viewApartmentMode = true
      } else {
        $vm.showLoader = true
        this.apartmentService.item(id, result => {
          $vm.currentApartment = result
          $vm.showLoader = false
          $vm.viewApartmentMode = true
        }, () => {
          $vm.showLoader = false
          $vm.$popup.error('Can\'t load Apartment #' + $vm.$formatter.formatID(id) + ' details')
        })
      }
    },

    addApartmentClose () {
      this.addApartmentMode = false
    },

    viewApartmentClose () {
      this.$refs.apartmentViewForm.cancelEditMode()
      this.viewApartmentMode = false
      this.apartmentEditMode = false
      this.currentApartment = { data: {} }
    },

    enterApartmentEditMode () {
      this.apartmentEditMode = true
    },

    doneAddApartment (e) {
      let $vm = this
      if (e.id) {
        this.addApartmentMode = false
        $vm.refresh()
        this.$popup.success('Apartment #' + e.data.code + ' successfully added to project.').then(() => {
        })
      } else {
        this.$popup.warning('Something going wrong...')
      }
    },

    doneEditApartment (e) {
      let $vm = this
      if (e.id) {
        this.viewApartmentMode = false
        $vm.refresh()
        this.$popup.success('Apartment #' + e.data.code + ' successfully saved.').then(() => {
        })
      } else {
        this.$popup.warning('Something going wrong...')
      }
    },

    checkChanges (e) {
      this.hasChanges = true
    },

    prepareData (obj) {
      let result = Object.assign({}, obj)
      result.is_public = result.is_public ? 1 : 0
      return result
    },

    canBeChanged () {
      let result = typeof this.object === 'object'
      result = result && this.object.status === 1
      return result
    },

    changePublicProject (event) {
      this.object.is_public = event.value
    },

    /** invoice can be **/

    /** **/

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    makeIdFilter () {
      this.idFilter = []
      if (this.object && Array.isArray(this.object.purchaseOrderProducts)) {
        for (let i in this.object.purchaseOrderProducts) {
          this.idFilter.push(this.object.purchaseOrderProducts[i].product_id)
        }
      }
    },

    /** action methods **/

    uploadComplete (file) {
      this.galleryEditMode = true
      this.$logger.log('uploadComplete', file)

      let image = file.uploaded.image || null
      if (!image) {
        this.$popup.warning('Uploaded file is not an image')
        return
      }

      image.isNew = true
      this.images.push(image)
      this.$forceUpdate()
    },

    uploadError (file) {
      this.$logger.log('uploadError', file)
      this.$popup.warning('Failed to upload file')
    },

    setupGallery () {
      this.images = []
      if (this.object && this.object.images) {
        this.object.images.forEach(item => {
          this.images.push(item)
        })
      }
    },

    removeImage (image) {
      this.galleryEditMode = true

      if (image.isNew) {
        this.images = this.images.filter(img => {
          return img !== image
        })
      } else {
        // console.log(this.images.indexOf(image))
        image.isDeleted = true
        this.images.splice(this.images.indexOf(image), 1, image)
      }

      // this.$forceUpdate()
    },

    saveGalleryData () {
      const imagesIds = this.activeImages.map(img => {
        return img.id
      })
      this.service.attachImages(this.id, { imagesIds: imagesIds }, () => {
        this.galleryEditMode = false
        this.refresh()
      })
    },

    cancelGalleryEditMode () {
      this.images = this.images.map(img => {
        img.isDeleted = false
        return img
      })

      this.images = this.images.filter(img => {
        return !img.isNew
      })

      this.galleryEditMode = false
    }
    /** sub-action methods **/
  },
  beforeDestroy () {
    this.object = {}
  }
}
</script>

<style scoped>
  .logo-image img {
    max-height: 112px;
    min-height: 112px;
    max-width: 100%;
    width: auto;
  }
</style>
